module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    attrs: {
      "model": this.equip,
      "label-position": "left"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Weight",
      "suffix": "kg",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.weight),
      callback: function($$v) {
        _vm.$set(_vm.equip, "weight", $$v)
      },
      expression: "equip.weight"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('float-input', {
    attrs: {
      "label": "Width",
      "suffix": "mm.",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.width),
      callback: function($$v) {
        _vm.$set(_vm.equip, "width", $$v)
      },
      expression: "equip.width"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Height",
      "suffix": "mm.",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.height),
      callback: function($$v) {
        _vm.$set(_vm.equip, "height", $$v)
      },
      expression: "equip.height"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Depth",
      "suffix": "mm.",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.depth),
      callback: function($$v) {
        _vm.$set(_vm.equip, "depth", $$v)
      },
      expression: "equip.depth"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('float-input', {
    attrs: {
      "label": "Diameter",
      "suffix": "⌀ m.",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.diameter),
      callback: function($$v) {
        _vm.$set(_vm.equip, "diameter", $$v)
      },
      expression: "equip.diameter"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44e2df08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/features/Dimensions.vue
// module id = 1452
// module chunks = 0